import React from "react";

class HeaderViewList extends React.Component {
  render() {
    const tabs = [];
    for (let i = 0; i < this.props.views.length; ) {
      const tabLayer = [];
      for (let j = 0; i < this.props.views.length && j < 8; j++, i++) {
        tabLayer.push(this.props.views[i]);
      }
      tabs.push(tabLayer);
    }
    return (
      <div className="container-fluid">
        <div className="row mt-1">
          <div className="col-md-12">
            <div className="content-box">
              <nav className="project-tab">
                {tabs.map((views, i) => (
                  <div key={`layer_tab_${i}`} className="nav nav-tabs nav-fill">
                    {views.map((view, j) => (
                      <div
                        key={`tab_${i * views.length + j}`}
                        className="col-md width-15"
                      >
                        <span
                          className={`alert-dark nav-item nav-link ${
                            this.props.view.id === view.id ? "active" : ""
                          }`}
                          onClick={() => this.props.onTabClick(view.id)}
                        >
                          {" "}
                          {view.name}{" "}
                        </span>
                      </div>
                    ))}
                  </div>
                ))}
              </nav>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default HeaderViewList;
